import { UseMutationOptions } from '@tanstack/react-query';

import { CuredApiPaths } from '../../models/enums';
import useMutation from '../useMutation';

import MutationKeys from './keys';

export type ScheduleABTestWinnerInput = {
    campaignId: string;
    scheduledTimestamp: string;
};

export type ScheduleABTestWinnerResponse = {
    success: boolean;
    message?: string;
};

/**
 * Schedules the winner of an A/B test to be sent to the remaining audience.
 * @param mutateOptions react-query useMutation option
 * @returns the react-query useMutation results
 * See https://react-query-v3.tanstack.com/reference/useMutation for options and return value
 */
const useScheduleABTestWinner = (
    mutateOptions?: UseMutationOptions<ScheduleABTestWinnerResponse, Error, ScheduleABTestWinnerInput>
) =>
    useMutation<ScheduleABTestWinnerInput, ScheduleABTestWinnerResponse>(
        MutationKeys.SCHEDULE_AB_TEST_WINNER,
        CuredApiPaths.CAMPAIGNS_AB_TEST_SCHEDULE_WINNER,
        mutateOptions
    );

export default useScheduleABTestWinner;
